import React from 'react';
import {Link} from 'react-router';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Button
} from 'reactstrap';
import CommuniqueShow from './CommuniqueShow';

export default class CommuniquesIndex extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showCommunique : null,
            deletingCommunique : null,
        }
    }

    componentWillMount() {
        this.props.fetchCommuniques();
    }

    componentWillReceiveProps(props) {
        if(this.props.communiques.deleting && ! props.communiques.deleting) {
            this.setState({
                deletingCommunique : null
            });
        }
    }

    render() {
        const {fetching, data} = this.props.communiques;
        return (
            <div className="container">
                <div className="text-right">
                    <Link to="/communiques/create" className="btn btn-primary">
                        <i className="fa fa-fw fa-plus"></i> Crear nuevo
                    </Link>
                </div>
                {
                    fetching ?
                    <div className="text-center">
                        <i className="fa fa-spinner fa-spin"></i> Cargando
                    </div>
                    :
                    <CommuniquesList communiques={data || []} showCommunique={communique => this.setState({showCommunique : communique})} deleteCommunique={communique => this.setState({deletingCommunique : communique})}/>
                }
                <Modal isOpen={this.state.showCommunique !== null} toggle={() => this.setState({showCommunique : null})} size="lg">
                    <ModalHeader toggle={() => this.setState({showCommunique : null})}>
                        {this.state.showCommunique ? this.state.showCommunique.title : null}
                    </ModalHeader>
                    <ModalBody>
                        <CommuniqueShow communique={this.state.showCommunique} />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.deletingCommunique !== null} toggle={() => this.setState({deletingCommunique : null})} size="sm">
                    <ModalBody>
                        ¿Está seguro que desea eliminar este comunicado?
                        <div className="text-right mt-3">
                            <Button size="sm" onClick={() => this.setState({deletingCommunique : null})} className="mr-1">Cancelar</Button>
                            <Button size="sm" onClick={() => this.props.deleteCommunique(this.state.deletingCommunique)} color="danger">Sí, eliminar</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

function CommuniquesList(props) {
    const {communiques} = props;
    return (
        <div className="row">
            {
                communiques.map((communique, i) => ([
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <CommuniqueCard communique={communique} showCommunique={props.showCommunique} deleteCommunique={props.deleteCommunique}/>
                    </div>,
                    (i+1) % 4 === 0 ? <div className="clearfix hidden-md-down"></div> : null,
                    (i+1) % 3 === 0 ? <div className="clearfix hidden-sm-down hidden-lg-up"></div> : null,
                    (i+1) % 2 === 0 ? <div className="clearfix hidden-md-up"></div> : null
                    
                ]))
            }
        </div>
    );
}

function CommuniqueCard(props) {
    const {communique} = props;
    if( ! communique ) return null;
    return (
        <div className="card">
            <img className="card-img-top" src={communique.cover_url} alt={communique.title}/>
            <div className="card-block">
                <h5 className="card-title mb-0">
                    {communique.title}
                </h5>
            </div>
            <div className="card-footer text-right">
                <button className="btn btn-secondary btn-sm mr-1" onClick={() => props.showCommunique(communique)}>
                    Detalle
                </button>
                <button className="btn btn-danger btn-sm" onClick={() => props.deleteCommunique(communique)}>
                    <i className="fa fa-times"></i> Eliminar
                </button>
            </div>
        </div>
    );
}



/** WEBPACK FOOTER **
 ** ./src/components/presentation/communiques/CommuniquesIndex.jsx
 **/